<!--
 * @Author: chencong
 * @Date: 2020-08-31 09:23:44
 * @LastEditTime: 2020-12-24 10:48:17
 * @LastEditors: ShiWeiShan
 * @Description: 富文本
 * @FilePath: \fs-js-pcweb-user\src\components\wangeditors\index.vue
-->
<template lang="html">
  <div class="wangeditor">
      <!-- <div ref="toolbar" class="toolbar"></div> -->
      <div ref="wangeditor" class="text"></div>
  </div>
</template>

<script>
import E from "wangeditor"
export default {
  data() {
    return {
      wangEditor: null,
      wangEditorInfo: null
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: String,
      default: ""
    }
    // isClear: {
    //   type: Boolean,
    //   default: false
    // }
  },
  watch: {
    // isClear(val) {
    //   // 触发清除文本域内容
    //   if (val) {
    //     this.wangEditor.txt.clear()
    //     this.wangEditorInfo = null
    //   }
    // },
    value: function(value) {
      if (value !== this.wangEditor.txt.html()) {
        // this.isClear = false
        this.wangEditor.txt.html(this.value) // value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
      }
    }
  },
  mounted() {
    this.initEditor()
    this.wangEditor.txt.html(this.value)
  },
  methods: {
    initEditor() {
      this.wangEditor = new E(this.$refs.wangeditor)
      this.wangEditor.config.menus = []
      // 创建富文本编辑器
      this.wangEditor.create()
      this.wangEditor.$textElem.attr('contenteditable', false) // 禁用编辑功能
    }
  }
}
</script>
 
<style lang="scss">
.wangeditor {
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  .toolbar {
    border-bottom: 1px solid #e6e6e6;
    box-sizing: border-box;
  }
  .text {
    min-height: 300px;
  }
}
</style>